var React = require('react');

function IconQuotationMarks (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Quotes"),React.createElement("path",{"d":"M8.28 15.44v-6.6H4.8V7.76c0-1.28.25-2.23.75-2.85.5-.62 1.27-.93 2.31-.93V.68c-2.48 0-4.36.73-5.64 2.19C.94 4.33.3 6.34.3 8.9c0 2.08.34 4.26 1.02 6.54h6.96zm10.14 0v-6.6h-3.48V7.76c0-1.28.25-2.23.75-2.85.5-.62 1.27-.93 2.31-.93V.68c-2.48 0-4.36.73-5.64 2.19-1.28 1.46-1.92 3.47-1.92 6.03 0 2.08.34 4.26 1.02 6.54h6.96zm5.58 0c2.48 0 4.35-.73 5.61-2.19 1.26-1.46 1.89-3.49 1.89-6.09 0-2.2-.32-4.36-.96-6.48h-6.96v6.54h3.48v1.14c0 1.28-.25 2.22-.75 2.82-.5.6-1.27.9-2.31.9v3.36zm10.14 0c2.48 0 4.36-.74 5.64-2.22 1.28-1.48 1.92-3.5 1.92-6.06 0-2.04-.34-4.2-1.02-6.48h-6.96v6.54h3.48v1.14c0 1.28-.25 2.22-.75 2.82-.5.6-1.27.9-2.31.9v3.36z","fill":"#FFF","fillRule":"nonzero","key":1})]);
}

IconQuotationMarks.defaultProps = {"viewBox":"0 0 42 16"};

module.exports = IconQuotationMarks;

IconQuotationMarks.default = IconQuotationMarks;
